import { Tag } from 'antd';

const MarginTag = ({ margin = 0 }) => {
    const getMarginStyles = () => {
        if (margin < 10) {
            return {
                backgroundColor: '#fef2f2',
                color: '#dc2626',
            };
        }

        if (margin < 15) {
            return {
                backgroundColor: '#fff7ed',
                color: '#ea580c',
            };
        }

        return {
            backgroundColor: '#ecfdf5',
            color: '#16a34a',
        };
    };

    const styles = getMarginStyles();

    return (
        <Tag
            className="border-round-lg font-bold px-2 py-1 border-none text-xs"
            style={{
                ...styles,
            }}
        >
            {margin?.toFixed(2)}%
        </Tag>)
}

export default MarginTag

